import {ISelect} from "@/components/Select/helper";
import {AppContext, APPEvent} from '@/ZRender/context';
import React, {useContext, useEffect, useState} from "react";
import './index.less';
import OrderFilter from "@/pages/order/filter";
import OrderList from "@/pages/order/table";

export default () => {
    const [params, setParams] = useState({})
    const [paymentStat, setPaymentStat] = useState<ISelect[]>([])
    const [orderStat, setOrderStat] = useState<ISelect[]>([])
    //@ts-ignore
    const {state, dispatch} = useContext(AppContext);

    useEffect(() => {
        if (state.isLogin === false) {
            dispatch({
                type: APPEvent.SHOWLOGIN,
                state: {showLogin: true}
            })
        }
    }, [state.isLogin])


    return (
        <div className="flex flex-column">
            <OrderFilter params={params} setParams={setParams} orderStat={orderStat} paymentStat={paymentStat}/>
            <OrderList params={params} setOrderStat={setOrderStat} setPaymentStat={setPaymentStat}/>
        </div>
    )
}